import moment from "moment";
import {
    addRelativeDateFilter,
    filterKeywordsByCustomDate,
    getActiveModule,
    setFilters,
} from "./utils";
import { CUSTOM_DATE_RANGE_LABEL, NUM_DAYS_SELECTABLE } from "./constants";
import $ from "jquery";
import { IDRange } from "./common-types";

const dateRangeValues = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 3 Days": [moment().subtract(3, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(7, "days"), moment().subtract(1, "days")],
    "Last Week": [
        moment().subtract(1, "week").startOf("week"),
        moment().subtract(1, "week").endOf("week"),
    ],
    "Last 14 Days": [moment().subtract(14, "days"), moment().subtract(1, "days")],
    "Last 30 Days": [
        moment().subtract(30, "days"),
        moment().subtract(1, "days"),
    ],
    "Current Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
    ],
};

let currentDateFilter = JSON.parse(sessionStorage.getItem("currentDateFilter"));
const lastCustomDate = JSON.parse(sessionStorage.getItem("data")) || {};
const defaultDateRange: string =
    sessionStorage.getItem("lastDateRange") || "Last 7 Days";
let selectDateRange;

export const dateRanges = new Proxy(dateRangeValues, {
    get: (dateRangeObj: Record<string, moment.Moment[]>, prop: string) =>
        prop === CUSTOM_DATE_RANGE_LABEL
            ? [moment(lastCustomDate.startDate), moment(lastCustomDate.endDate)]
            : dateRangeObj[prop],
});

export function getSelectableDateRange() {
    return {
        minDate: moment().subtract(NUM_DAYS_SELECTABLE + 1, "days"),
        maxDate: moment().subtract(1, "days"),
    };
}

export function getSelectedDateRange() {
    const currentDateRange =
        sessionStorage.getItem("lastDateRange") || defaultDateRange;
    const selectedDate =
        JSON.parse(sessionStorage.getItem("date")) ||
        dateRanges[currentDateRange];
    return {
        dateRange: currentDateRange,
        startDate: moment(selectedDate.startDate || selectedDate[0]),
        endDate: moment(selectedDate.endDate || selectedDate[1]),
    };
}

export function getDateObj() {
    const selectedDate = getSelectedDateRange();
    return selectedDate.dateRange === CUSTOM_DATE_RANGE_LABEL
        ? {
              start: selectedDate.startDate.format("YYYY-MM-DD"),
              end: selectedDate.endDate.format("YYYY-MM-DD"),
          }
        : { selectedDate: selectedDate.dateRange };
}

const updateDateFilters = () => {
    let activeFilters = JSON.parse(sessionStorage.getItem("activeFilters"));
    activeFilters = { ...activeFilters, ...currentDateFilter };
    sessionStorage.setItem("activeFilters", JSON.stringify(activeFilters));
    if(getActiveModule().activeParentModule !== "review-analytics"){
       setFilters();     
    }
};

export async function onDateChangeHandler(dateRangeKey: IDRange | string) {
    $("#reportrange span").html(
        `${dateRanges[dateRangeKey][0].format("DD-MMM-YY")} to ${dateRanges[
            dateRangeKey
        ][1].format("DD-MMM-YY")}`
    );
    currentDateFilter = addRelativeDateFilter("report_date", dateRangeKey);
    sessionStorage.setItem(
        "currentDateFilter",
        JSON.stringify(currentDateFilter)
    );
    selectDateRange = dateRangeKey;
    sessionStorage.setItem(
        "date",
        JSON.stringify({
            startDate: dateRanges[dateRangeKey][0],
            endDate: dateRanges[dateRangeKey][1],
        })
    );

    if (dateRangeKey !== sessionStorage.getItem("lastDateRange")) {
        sessionStorage.setItem("lastDateRange", dateRangeKey);
    }
    updateDateFilters();
}

export function onCustomDateChangeHandler(
    start: moment.Moment,
    end: moment.Moment
) {
    $("#reportrange span").html(
        `${start.format("DD-MMM-YY")} to ${end.format("DD-MMM-YY")}`
    );
    selectDateRange = CUSTOM_DATE_RANGE_LABEL;
    currentDateFilter = filterKeywordsByCustomDate(start, end);
    sessionStorage.setItem(
        "currentDateFilter",
        JSON.stringify(currentDateFilter)
    );
    sessionStorage.setItem(
        "date",
        JSON.stringify({
            startDate: start,
            endDate: end,
        })
    );
    sessionStorage.setItem("lastDateRange", selectDateRange);
    updateDateFilters();
}
